import { connect } from 'react-redux';
import React from 'react';
import { Form } from 'antd';
import { KBFormError,
KBButton,
KBSelect,
KBRadio } from
'components';
import {
  CAN_BINDING_CARD,
  CAN_SET_TOUCH_PASSWORD,
  DISPLAY_BLUETOOTH_LOCK,
  NEED_CLOSE_TO_LOCK
} from 'app/constants';
import * as selectors from 'app/selectors';

const getChangeValue = value => (value && value.target ? value.target.value : value);

function FormField({ children, onChange, value }) {
  return children({
    value,
    onChange: nextValue => onChange(getChangeValue(nextValue))
  });
}

function LocationSetLock({ error, locationSetting, updateLocationSetting }) {
  const [form] = Form.useForm();
  const [submitting, setSubmitting] = React.useState(false);
  const initialValues = React.useMemo(
    () => getInitialValues(locationSetting),
    [locationSetting]
  );
  const initialValuesKey = JSON.stringify(initialValues);

  React.useEffect(() => {
    form.setFieldsValue(initialValues);
  }, [form, initialValuesKey]);

  const renderField = (name, render) => (
    <Form.Item name={name} noStyle>
      <FormField>{render}</FormField>
    </Form.Item>
  );

  const setLocationSetting = formValues => {
    const model = {
      can_binding_card: formValues.can_binding_card == 'true',
      can_set_touch_password: formValues.can_set_touch_password == 'true',
      display_bluetooth_lock: formValues.display_bluetooth_lock == 'true',
      need_close_to_lock: formValues.need_close_to_lock == 'true'
    };

    return updateLocationSetting(
      {
        lock_settings: model
      },
      {
        key: 'lock_settings'
      }
    );
  };

  const handleFinish = () => {
    setSubmitting(true);
    const result = setLocationSetting(form.getFieldsValue());
    if (result && result.then) {
      return result.then(
        value => {
          setSubmitting(false);
          return value;
        },
        requestError => {
          setSubmitting(false);
          throw requestError;
        }
      );
    }
    setSubmitting(false);
    return result;
  };

  const isNearOpenLock = [
    { title: '是', value: true },
    { title: '否', value: false }
  ];

  return (
    <div className="nav-section-content-container" style={{ padding: 0 }}>
      <header className="nav-header">
        <div className="nav-section-header-title">
          <span>门禁设置</span>
        </div>
      </header>
      <div className="kb-form-container">
        <Form form={form} initialValues={initialValues} onFinish={handleFinish}>
          <KBFormError error={error} />
          <div className="kb-form-container" style={{ padding: '0 400px 0 0' }}>
            <div className="kb-row">
              {renderField('can_binding_card', field => (
                <KBSelect
                  defaultValue={'-1'}
                  className="kb-form-group kb-div-210 kb-form-alone"
                  title="自行绑卡"
                  field={field}

                  arrayData={CAN_BINDING_CARD}
                />
              ))}
            </div>
            <div className="kb-row">
              {renderField('can_set_touch_password', field => (
                <KBSelect
                  defaultValue={'-1'}
                  className="kb-form-group kb-div-210 kb-form-alone"
                  title="触摸密码"
                  field={field}

                  arrayData={CAN_SET_TOUCH_PASSWORD}
                />
              ))}
            </div>
            <div className="kb-row">
              {renderField('display_bluetooth_lock', field => (
                <KBSelect
                  defaultValue={'-1'}
                  className="kb-form-group kb-div-210 kb-form-alone"
                  title="蓝牙门禁"
                  field={field}

                  arrayData={DISPLAY_BLUETOOTH_LOCK}
                />
              ))}
            </div>
            <div className="kb-row" style={{ marginTop: 15 }}>
              {renderField('need_close_to_lock', field => (
                <KBRadio
                  className="kb-form-group kb-div-210 kb-form-alone"
                  inClassName="kb-form-group kb-div-33"
                  groupStyle={{ width: '100%' }}
                  divClassName="kb-form-group kb-div-66-active"
                  rightLabel="label-rt"
                  title="靠近开门"
                  arrayType={isNearOpenLock}
                  name="external"
                  field={field}
                />
              ))}
              <p style={{ fontSize: 12, color: '#666666', marginTop: 5 }}>
                备注：设置是否需要靠近门禁才能开门
              </p>
            </div>
            <div className="kb-row m-top">
              <KBButton className="certain-btn" type="submit" submitting={submitting}>
                保存
              </KBButton>
            </div>
          </div>
        </Form>
      </div>
    </div>
  );
}

function mapStateToProps(state, props) {
  const loc_id = props.params.id;
  return {
    locationSetting: selectors.getLocationSetting(state, loc_id)
  };
}

const getBooleanString = value =>
  value === true || value === false ? value + '' : value;

const getInitialValues = (setting = {}) => {
  const lockSettings = setting.lock_settings || {};
  return {
    can_binding_card: getBooleanString(lockSettings.can_binding_card),
    can_set_touch_password: getBooleanString(lockSettings.can_set_touch_password),
    display_bluetooth_lock: getBooleanString(lockSettings.display_bluetooth_lock),
    need_close_to_lock: getBooleanString(lockSettings.need_close_to_lock)
  };
};

export default connect(mapStateToProps)(LocationSetLock);
